import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Allow access to profile completion page
  if (location.pathname === '/complete-profile') {
    return <Outlet />;
  }

  // Check if user has completed their profile
  if (user && user.profile) {
    // If profile exists but is not complete, redirect to completion
    if (!user.profile.profile_picture ||
        user.profile.alcohol_preference === null ||
        user.profile.smoking === null ||
        !user.profile.entertainments ||
        !user.profile.seeking ||
        !user.profile.relationship_status_detailed ||
        user.profile.latitude === null ||
        user.profile.longitude === null) {
      return <Navigate to="/complete-profile" replace />;
    }
  }

  return <Outlet />;
};

export default PrivateRoute;
